<template>
  <v-card
      height="330"
      class="rounded-lg white"
  >
    <v-card-title class=" mr-3 mt-3 secondary--text">
      <v-img class="ml-3" src="/img/icons/time-alert.svg" max-width="25" max-height="25"></v-img>
      آخرین یادآور ها
      <v-spacer></v-spacer>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="notificationForm/reminder">
            <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
          </v-btn>
        </template>
        مشاهده کامل
      </v-tooltip>
    </v-card-title>
    <v-simple-table class="mr-2 ml-2 rounded-b-lg">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">
            عنوان
          </th>
          <th class="text-center">
            توضیحات
          </th>
          <th class="text-center">
            تاریخ
          </th>
          <th class="text-center">
            ساعت
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="reminder in reminders">
          <td class="text-center">{{reminder.title}}</td>
          <td class="text-center">{{reminder.explanation}}</td>
          <td class="text-center">{{reminder.send_date}}</td>
          <td class="text-center">{{reminder.send_time}}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: "LastReminders",
  components: {},
  props: {
    id: {},
  },
  data() {
    return {
      reminders: null
    };
  },
  mounted() {
    this.request({
      url: this.endpoint('users/reminderNotification/?limit=5&offset=0&search='),
      method: "get",
      success: data => {
        this.reminders = data.results.slice(0,4)
      },
    })


  }

}
</script>

<style scoped lang="scss"></style>

